const Loader = () => {
  return (
    <div className=" fixed w-full h-full bg-gray-900 top-0 left-0 z-[98] ">
    <span className="loading loading-dots loading-lg absolute top-1/2 left-1/2 text-white "></span>
    </div>
  )
}

export default Loader